import React from "react";
import ChristmasImage from "../../assets/images/christmas.jpg";

const DevotionalCard = ({ devotional, onAdd }) => {
      return (
    <div className="flex flex-col min-w-[150px] overflow-hidden">
      <img
        src={devotional?.devotionalsCoverImageUrl || ChristmasImage}
        alt={devotional.devotionalTitle}
        className="w-full h-[100px] object-cover rounded-lg"
      />

      <div className="p-2 flex flex-col flex-1">
        <h3 className="text-sm font-semibold text-white truncate">
          {devotional.devotionalTitle}
        </h3>
        <p className="text-xs text-gray-400 mt-1 truncate">
          {devotional.devotionalDescription}
        </p>

        <button
          onClick={() => {
                        onAdd && onAdd();
          }}
          className="mt-2 w-[80%] bg-white text-black text-xs font-semibold py-1 rounded-[50px]"
        >
          Add
        </button>
      </div>
    </div>
  );
};

export default DevotionalCard;